const state = {
  screenWidth: document.documentElement.clientWidth,
  screenHeight: document.documentElement.clientHeight,
  fromAddress: '',
  activeRoute: {},
  isLogin: false // 检测用户是否重新登录
};

export default state;
